
import { redirect } from '../common/client/sagas/common';

import history from '../history';

export const PAGE_USEK_INPUT = {id: 1, pathname: '/step1', title: 'Návrh úseků mezí'};
export const PAGE_USEK_ATTRS = {id: 2, pathname: '/step2', title: 'Vlastnosti úseků mezí'};
export const PAGE_PRICELIST = {id: 3, pathname: '/step3', title: 'Ceník prací a materiálů'};
export const PAGE_CALC = {id: 4, pathname: '/step4', title: 'Kalkulace'};

export const PAGES = [PAGE_USEK_INPUT, PAGE_USEK_ATTRS, PAGE_PRICELIST, PAGE_CALC];

export function redirectToPage(page) {
    redirect(page.pathname, {history});
}
